const init = (item, number) => {
	item.each((index, item) => {
		let currentItem = $(item);
		let slice = currentItem.text().slice(0, number);
		if(currentItem.text().length > number) {
			currentItem.text(slice + '...')
		}
	});
};

export default {
	init,
}
